import { render, staticRenderFns } from "./ConsumerToken-list.vue?vue&type=template&id=52eeb3ca&"
import script from "./ConsumerToken-list.vue?vue&type=script&lang=js&"
export * from "./ConsumerToken-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports